import React from 'react';
import { Typography, PunchOut } from '@hpi-sox/hpstellar-core';
import TypographyVisId from '@hpi-sox/hpstellar-core/visId/Typography';
import withPageComponents from '../../../page/components/with-page-components';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import DeliveryMessage from '../sticky-header/delivery-message';
import ProductIdentityDetails from '../product-identity-details';
import { Helpers } from '../../../core/src/helpers';
import './configure-title.less';
import SavingsProgressBar from '../savings-progress-bar';

export default withPageComponents(
    ({ baseConfig = {}, device, ctoPrice: price, customizeText = 'Build your', froggerMessage }) => {
        const {
            title,
            image,
            disclaimer = '*Price and promotions vary depending on selected configuration',
            shipsText,
            alternateImage,
        } = baseConfig;
        const shippingMessage = froggerMessage || shipsText;
        return (
            <>
                {device === 'mobile' && <SavingsProgressBar />}
                <div className="configure-title">
                    {device !== 'mobile' ? (
                        <>
                            <Typography tag="h2" variant="bodyL" className="sub-header">
                                Configure your
                            </Typography>
                            <Typography tag="h1" variant="titleM">
                                {title}
                            </Typography>
                            <ProductIdentityDetails />
                            <Typography variant="bodyS">{disclaimer}</Typography>
                        </>
                    ) : (
                        <>
                            {image && (
                                <AdaptiveImage
                                    className="product-image"
                                    src={Helpers.purifyUrl(alternateImage || image)}
                                    maxWidth={152}
                                    prefetch={true}
                                />
                            )}
                            <div className="sub-header-wrapper">
                                <TypographyVisId tag="h2" variant="body2" weight="700" className="customize-text">
                                    {customizeText}
                                </TypographyVisId>
                                <Typography tag="h1" variant="titleM" className="sub-header">
                                    {title}
                                </Typography>
                                <ProductIdentityDetails />
                                <DeliveryMessage />
                            </div>
                            {price && !price.error && price.gmPoints && <PunchOut grossMargin={price.gmPoints} />}
                        </>
                    )}
                </div>
                {device === 'mobile' && shippingMessage && (
                    <Typography
                        variant="bodyS"
                        className="shipping-html"
                        dangerouslySetInnerHTML={Helpers.createMarkup(shippingMessage)}
                    />
                )}
            </>
        );
    },
    { components: ['baseConfig', 'ctoProductInitial', 'ctoPrice', 'shipDate', 'froggerMessage'], device: true },
);
